/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

tinymce.addI18n('sl', {
  "Redo": "Ponovno uveljavi",
  "Undo": "Razveljavi",
  "Cut": "Izre\u017ei",
  "Copy": "Kopiraj",
  "Paste": "Prilepi",
  "Select all": "Izberi vse",
  "New document": "Nov dokument",
  "Ok": "V redu",
  "Cancel": "Prekli\u010di",
  "Visual aids": "Vizualni pripomo\u010dki",
  "Bold": "Krepko",
  "Italic": "Po\u0161evno",
  "Underline": "Pod\u010drtano",
  "Strikethrough": "Pre\u010drtano",
  "Superscript": "Nadpisano",
  "Subscript": "Podpisano",
  "Clear formatting": "Odstrani oblikovanje",
  "Align left": "Leva poravnava",
  "Align center": "Sredinska poravnava",
  "Align right": "Desna poravnava",
  "Justify": "Obojestranska poravnava",
  "Bullet list": "Ozna\u010den seznam",
  "Numbered list": "O\u0161tevil\u010den seznam",
  "Decrease indent": "Zmanj\u0161aj zamik",
  "Increase indent": "Pove\u010daj zamik",
  "Close": "Zapri",
  "Formats": "Oblika",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X\/C\/V keyboard shortcuts instead.": "Varnostne nastavitve brskalnika ne dopu\u0161\u010dajo direktnega dostopa do odlo\u017ei\u0161\u010da. Uporabite kombinacijo tipk Ctrl + X\/C\/V na tipkovnici.",
  "Headers": "Naslovi",
  "Header 1": "Naslov 1",
  "Header 2": "Naslov 2",
  "Header 3": "Naslov 3",
  "Header 4": "Naslov 4",
  "Header 5": "Naslov 5",
  "Header 6": "Naslov 6",
  "Headings": "Naslovi",
  "Heading 1": "Naslov 1",
  "Heading 2": "Naslov 2",
  "Heading 3": "Naslov 3",
  "Heading 4": "Naslov 4",
  "Heading 5": "Naslov 5",
  "Heading 6": "Naslov 6",
  "Preformatted": "Predformatirano",
  "Div": "Div",
  "Pre": "Pre",
  "Code": "Koda",
  "Paragraph": "Odstavek",
  "Blockquote": "Blockquote",
  "Inline": "Med besedilom",
  "Blocks": "Bloki",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Odlagali\u0161\u010de je sedaj v tekstovnem na\u010dinu. Vsebina bo preslikana kot besedilo, dokler te mo\u017enosti ne izklju\u010dite.",
  "Fonts": "Pisave",
  "Font Sizes": "Velikosti pisave",
  "Class": "Razred",
  "Browse for an image": "Prebrskaj za sliko",
  "OR": "ALI",
  "Drop an image here": "Spusti sliko sem",
  "Upload": "Nalo\u017ei",
  "Block": "Blok",
  "Align": "Poravnava",
  "Default": "Privzeto",
  "Circle": "Krog",
  "Disc": "Disk",
  "Square": "Kvadrat",
  "Lower Alpha": "Mala alfa",
  "Lower Greek": "Male gr\u0161ke \u010drke",
  "Lower Roman": "Male rimske \u0161tevilke",
  "Upper Alpha": "Velika alfa",
  "Upper Roman": "Velike rimske \u0161tevilke",
  "Anchor...": "Sidro ...",
  "Name": "Naziv",
  "Id": "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "Id se mora za\u010deti s \u010drko, sledijo samo \u010drke, \u0161tevilke, pomi\u0161ljaji, pike, dvopi\u010dja ali pod\u010drtaji.",
  "You have unsaved changes are you sure you want to navigate away?": "Imate neshranjene spremembe. Ste prepri\u010dati, da \u017eelite zapustiti stran?",
  "Restore last draft": "Obnovi zadnji osnutek",
  "Special character...": "Poseben znak ...",
  "Source code": "Izvorna koda",
  "Insert\/Edit code sample": "Vstavi\/Uredi vzor\u010dno kodo",
  "Language": "Jezik",
  "Code sample...": "Vzor\u010dna koda ...",
  "Color Picker": "Izbirnik barve",
  "R": "R",
  "G": "G",
  "B": "B",
  "Left to right": "Od leve proti desni",
  "Right to left": "Od desne proti levi",
  "Emoticons": "\u010custveni simboli",
  "Emoticons...": "\u010custveni simboli ...",
  "Metadata and Document Properties": "Metapodatki in lastnosti dokumenta",
  "Title": "Naslov",
  "Keywords": "Klju\u010dne besede",
  "Description": "Opis",
  "Robots": "Robotki",
  "Author": "Avtor",
  "Encoding": "Kodiranje",
  "Fullscreen": "\u010cez cel zaslon",
  "Action": "Dejanje",
  "Shortcut": "Bli\u017enjica",
  "Help": "Pomo\u010d",
  "Address": "Naslov",
  "Focus to menubar": "Poudarek na menijski vrstici",
  "Focus to toolbar": "Poudarek na orodni vrstici",
  "Focus to element path": "Poudarek na poti elementa",
  "Focus to contextual toolbar": "Poudarek na kontekstualni orodni vrstici",
  "Insert link (if link plugin activated)": "Vstavi povezavo (\u010de je aktiviran vti\u010dnik za povezavo)",
  "Save (if save plugin activated)": "Shrani (\u010de je aktiviran vti\u010dnik za shranjevanje)",
  "Find (if searchreplace plugin activated)": "I\u0161\u010di (\u010de je aktiviran vti\u010dnik za iskanje\/zamenjavo)",
  "Plugins installed ({0}):": "Name\u0161\u010deni vti\u010dniki ({0}):",
  "Premium plugins:": "Premium vti\u010dniki:",
  "Learn more...": "Ve\u010d ...",
  "You are using {0}": "Uporabljate {0}",
  "Plugins": "Vti\u010dniki",
  "Handy Shortcuts": "Uporabne bli\u017enjice",
  "Horizontal line": "Vodoravna \u010drta",
  "Insert\/edit image": "Vstavi\/uredi sliko",
  "Alternative description": "Nadomestni opis",
  "Accessibility": "Dostopnost",
  "Image is decorative": "Slika je okrasna",
  "Source": "Pot",
  "Dimensions": "Dimenzije",
  "Constrain proportions": "Obdr\u017ei razmerje",
  "General": "Splo\u0161no",
  "Advanced": "Napredno",
  "Style": "Slog",
  "Vertical space": "Navpi\u010dni prostor",
  "Horizontal space": "Vodoravni prostor",
  "Border": "Meja",
  "Insert image": "Vnesi sliko",
  "Image...": "Slika ...",
  "Image list": "Seznam slik",
  "Rotate counterclockwise": "Zavrti v nasprotni smeri urnega kazalca",
  "Rotate clockwise": "Zavrti v smeri urnega kazalca",
  "Flip vertically": "Obrni navpi\u010dno",
  "Flip horizontally": "Obrni vodoravno",
  "Edit image": "Uredi sliko",
  "Image options": "Mo\u017enosti slike",
  "Zoom in": "Pove\u010daj",
  "Zoom out": "Pomanj\u0161aj",
  "Crop": "Obre\u017ei",
  "Resize": "Spremeni velikost",
  "Orientation": "Usmerjenost",
  "Brightness": "Svetlost",
  "Sharpen": "Izostri",
  "Contrast": "Kontrast",
  "Color levels": "Barvni nivo",
  "Gamma": "Gama",
  "Invert": "Obrni",
  "Apply": "Uporabi",
  "Back": "Nazaj",
  "Insert date\/time": "Vstavi datum\/\u010das",
  "Date\/time": "Datum\/\u010das",
  "Insert\/edit link": "Vstavi\/uredi povezavo",
  "Text to display": "Besedilo za prikaz",
  "Url": "Povezava",
  "Open link in...": "Odpri povezavo v ...",
  "Current window": "Trenutno okno",
  "None": "Brez",
  "New window": "Novo okno",
  "Open link": "Odpri povezavo",
  "Remove link": "Odstrani povezavo",
  "Anchors": "Sidra",
  "Link...": "Povezava ...",
  "Paste or type a link": "Prilepite ali vnesite povezavo",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Vneseni URL predstavlja e-po\u0161tni naslov. Ali \u017eelite dodati potrebno predpono \"mailto:\"?",
  "The URL you entered seems to be an external link. Do you want to add the required http:\/\/ prefix?": "Vneseni URL predstavlja zunanjo povezavo. Ali \u017eelite dodati predpono \"http:\/\/\"?",
  "The URL you entered seems to be an external link. Do you want to add the required https:\/\/ prefix?": "Vneseni URL naslov predstavlja zunanjo povezavo. Ali mu \u017eelite dodati predpono https:\/\/ ?",
  "Link list": "Seznam povezav",
  "Insert video": "Vstavi video",
  "Insert\/edit video": "Vstavi\/uredi video",
  "Insert\/edit media": "Vstavi\/uredi medij",
  "Alternative source": "Nadomestni vir",
  "Alternative source URL": "Nadomestni vir URL",
  "Media poster (Image URL)": "Medijski poster (URL slike)",
  "Paste your embed code below:": "Spodaj prilepite kodo za vdelavo:",
  "Embed": "Vdelaj",
  "Media...": "Mediji ...",
  "Nonbreaking space": "Nedeljivi presledek",
  "Page break": "Prelom strani",
  "Paste as text": "Vnesi kot besedilo",
  "Preview": "Predogled",
  "Print...": "Natisni ...",
  "Save": "Shrani",
  "Find": "Najdi",
  "Replace with": "Zamenjaj z",
  "Replace": "Zamenjaj",
  "Replace all": "Zamenjaj vse",
  "Previous": "Prej\u0161nja",
  "Next": "Naslednja",
  "Find and Replace": "Najdi in zamenjaj",
  "Find and replace...": "Najdi in zamenjaj ...",
  "Could not find the specified string.": "Iskanje ni vrnilo rezultatov.",
  "Match case": "Ujemanje malih in velikih \u010drk",
  "Find whole words only": "I\u0161\u010di samo cele besede",
  "Find in selection": "I\u0161\u010di v izboru",
  "Spellcheck": "\u010crkovalnik",
  "Spellcheck Language": "Jezik \u010drkovalnika",
  "No misspellings found.": "Ni najdenih napak v \u010drkovanju.",
  "Ignore": "Prezri",
  "Ignore all": "Prezri vse",
  "Finish": "Zaklju\u010di",
  "Add to Dictionary": "Dodaj v slovar",
  "Insert table": "Vstavi tabelo",
  "Table properties": "Lastnosti tabele",
  "Delete table": "Izbri\u0161i tabelo",
  "Cell": "Celica",
  "Row": "Vrstica",
  "Column": "Stolpec",
  "Cell properties": "Lastnosti celice",
  "Merge cells": "Zdru\u017ei celice",
  "Split cell": "Razdeli celico",
  "Insert row before": "Vstavi vrstico pred",
  "Insert row after": "Vstavi vrstico za",
  "Delete row": "Izbri\u0161i vrstico",
  "Row properties": "Lastnosti vrstice",
  "Cut row": "Izre\u017ei vrstico",
  "Copy row": "Kopiraj vrstico",
  "Paste row before": "Prilepi vrstico pred",
  "Paste row after": "Prilepi vrstico za",
  "Insert column before": "Vstavi stolpec pred",
  "Insert column after": "Vstavi stolpec za",
  "Delete column": "Izbri\u0161i stolpec",
  "Cut column": "Izre\u017ei stolpec",
  "Copy column": "Kopiraj stolpec",
  "Paste column before": "Prilepi stolpec pred",
  "Paste column after": "Prilepi stolpec po",
  "Cols": "Stolpci",
  "Rows": "Vrstice",
  "Width": "\u0160irina",
  "Height": "Vi\u0161ina",
  "Cell spacing": "Razmik med celicami",
  "Cell padding": "Polnilo med celicami",
  "Caption": "Naslov",
  "Show caption": "Poka\u017ei napis",
  "Left": "Leva",
  "Center": "Sredinska",
  "Right": "Desna",
  "Cell type": "Tip celice",
  "Scope": "Obseg",
  "Alignment": "Poravnava",
  "H Align": "Vodoravna poravnava",
  "V Align": "Navpi\u010dna poravnava",
  "Top": "Vrh",
  "Middle": "Sredina",
  "Bottom": "Dno",
  "Header cell": "Celica glave",
  "Row group": "Grupiranje vrstic",
  "Column group": "Grupiranje stolpcev",
  "Row type": "Tip vrstice",
  "Header": "Header",
  "Body": "Vsebina",
  "Footer": "Footer",
  "Border color": "Barva obrobe",
  "Insert template...": "Vstavi predlogo ...",
  "Templates": "Predloge",
  "Template": "Predloga",
  "Text color": "Barva besedila",
  "Background color": "Barva ozadja",
  "Custom...": "Po meri ...",
  "Custom color": "Barva po meri",
  "No color": "Brezbarvno",
  "Remove color": "Odstrani barvo",
  "Table of Contents": "Kazalo",
  "Show blocks": "Prika\u017ei bloke",
  "Show invisible characters": "Prika\u017ei skrite znake",
  "Word count": "\u0160tevilo besed",
  "Count": "\u0160tevilo",
  "Document": "Dokument",
  "Selection": "Izbor",
  "Words": "Besede",
  "Words: {0}": "Besed: {0}",
  "{0} words": "{0} besed",
  "File": "Datoteka",
  "Edit": "Uredi",
  "Insert": "Vstavi",
  "View": "Pogled",
  "Format": "Oblika",
  "Table": "Tabela",
  "Tools": "Orodja",
  "Powered by {0}": "Uporablja tehnologijo {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Bogato besedilo. Pritisnite ALT-F9 za meni. Pritisnite ALT-F10 za orodno vrstico. Pritisnite ALT-0 za pomo\u010d",
  "Image title": "Naslov slike",
  "Border width": "\u0160irina obrobe",
  "Border style": "Slog obrobe",
  "Error": "Napaka",
  "Warn": "Opozorilo",
  "Valid": "Veljavno",
  "To open the popup, press Shift+Enter": "Za odpiranje pojavnega okna pritisnite Shift + Enter.",
  "Rich Text Area. Press ALT-0 for help.": "Bogato besedilo. Pritisnite ALT-0 za pomo\u010d.",
  "System Font": "Sistemska pisava",
  "Failed to upload image: {0}": "Napaka nalaganja slike: {0}",
  "Failed to load plugin: {0} from url {1}": "Napaka nalaganja vti\u010dnika: {0} z url {1}",
  "Failed to load plugin url: {0}": "Napaka nalaganja url: {0}",
  "Failed to initialize plugin: {0}": "Napaka inicializacije vti\u010dnika: {0}",
  "example": "primer",
  "Search": "Iskanje",
  "All": "Vse",
  "Currency": "Valuta",
  "Text": "Besedilo",
  "Quotations": "Citati",
  "Mathematical": "Matemati\u010dno",
  "Extended Latin": "Raz\u0161irjena latinica",
  "Symbols": "Simboli",
  "Arrows": "Pu\u0161\u010dice",
  "User Defined": "Uporabnik dolo\u010den",
  "dollar sign": "znak za dolar",
  "currency sign": "znak za valuto",
  "euro-currency sign": "znak za evro",
  "colon sign": "znak za dvopi\u010dje",
  "cruzeiro sign": "znak za cruzeiro",
  "french franc sign": "znak za francoski frank",
  "lira sign": "znak za liro",
  "mill sign": "znak za mill",
  "naira sign": "znak za nairo",
  "peseta sign": "znak za peseto",
  "rupee sign": "znak za rupijo",
  "won sign": "znak za won",
  "new sheqel sign": "znak za novi \u0161ekl",
  "dong sign": "znak za dong",
  "kip sign": "znak za kip",
  "tugrik sign": "znak za tugrik",
  "drachma sign": "znak za drahmo",
  "german penny symbol": "znak za nem\u0161ki peni",
  "peso sign": "znak za peso",
  "guarani sign": "znak za guarani",
  "austral sign": "znak za austral",
  "hryvnia sign": "znak za hrivnijo",
  "cedi sign": "znak za cedi",
  "livre tournois sign": "znak za livre tournois",
  "spesmilo sign": "znak za spesmilo",
  "tenge sign": "znak za tenge",
  "indian rupee sign": "znak za indijsko rupijo",
  "turkish lira sign": "znak za tur\u0161ko liro",
  "nordic mark sign": "znak za nordijsko marko",
  "manat sign": "znak za manat",
  "ruble sign": "znak za rubelj",
  "yen character": "znak za jen",
  "yuan character": "znak za yuan",
  "yuan character, in hong kong and taiwan": "znak za yuan, v Hongkongu in na Tajvanu",
  "yen\/yuan character variant one": "znak za jen\/yuan, prva razli\u010dica",
  "Loading emoticons...": "Nalaganje \u010dustvenih simbolov ...",
  "Could not load emoticons": "\u010custvenih simbolov ni mogo\u010de nalo\u017eiti.",
  "People": "Ljudje",
  "Animals and Nature": "\u017divali in narava",
  "Food and Drink": "Hrana in pija\u010da",
  "Activity": "Dejavnost",
  "Travel and Places": "Potovanja in kraji",
  "Objects": "Predmeti",
  "Flags": "Zastave",
  "Characters": "Znaki",
  "Characters (no spaces)": "Znaki (brez presledkov)",
  "{0} characters": "{0} znakov",
  "Error: Form submit field collision.": "Napaka: navzkri\u017eje polja za oddajo obrazca",
  "Error: No form element found.": "Napaka: elementa oblike ni mogo\u010de najti",
  "Update": "Posodobitev",
  "Color swatch": "Vzorec barv",
  "Turquoise": "Turkizna",
  "Green": "Zelena",
  "Blue": "Modra",
  "Purple": "\u0160krlatna",
  "Navy Blue": "Mornarsko modra",
  "Dark Turquoise": "Temno turkizna",
  "Dark Green": "Temno zelena",
  "Medium Blue": "Srednje modra",
  "Medium Purple": "Srednje \u0161krlatna",
  "Midnight Blue": "Polno\u010dno modra",
  "Yellow": "Rumena",
  "Orange": "Oran\u017ena",
  "Red": "Rde\u010da",
  "Light Gray": "Svetlo siva",
  "Gray": "Siva",
  "Dark Yellow": "Temno rumena",
  "Dark Orange": "Temno oran\u017ena",
  "Dark Red": "Temno rde\u010da",
  "Medium Gray": "Srednje siva",
  "Dark Gray": "Temno siva",
  "Light Green": "Svetlo zelena",
  "Light Yellow": "Svetlo rumena",
  "Light Red": "Svetlo rde\u010da",
  "Light Purple": "Svetlo vijoli\u010dna",
  "Light Blue": "Svetlo modra",
  "Dark Purple": "Temno vijoli\u010dna",
  "Dark Blue": "Temno modra",
  "Black": "\u010crna",
  "White": "Bela",
  "Switch to or from fullscreen mode": "Preklopi v ali iz celozaslonskega na\u010dina",
  "Open help dialog": "Odpri pogovorno okno za pomo\u010d",
  "history": "zgodovina",
  "styles": "slogi",
  "formatting": "oblikovanje",
  "alignment": "poravnava",
  "indentation": "zamik",
  "Font": "Pisava",
  "Size": "Velikost",
  "More...": "Ve\u010d ...",
  "Select...": "Izberi ...",
  "Preferences": "Preference",
  "Yes": "Da",
  "No": "Ne",
  "Keyboard Navigation": "Krmarjenje s tipkovnico",
  "Version": "Razli\u010dica",
  "Code view": "Prikaz kode",
  "Open popup menu for split buttons": "Odpri pojavni meni za razdeljene gumbe",
  "List Properties": "Lastnosti seznama",
  "List properties...": "Lastnosti seznama...",
  "Start list at number": "Za\u010dni seznam s \u0161tevilko",
  "Line height": "Vi\u0161ina vrstice",
  "comments": "komentarji",
  "Format Painter": "Preslikovalnik Oblik",
  "Insert\/edit iframe": "Vstavi\/uredi iFrame",
  "Capitalization": "Velika za\u010detnica",
  "lowercase": "male \u010drke",
  "UPPERCASE": "VELIKE \u010cRKE",
  "Title Case": "Velike za\u010detnice naslovov",
  "permanent pen": "permanentno pisalo",
  "Permanent Pen Properties": "Lastnosti permanentnega pisala",
  "Permanent pen properties...": "Lastnosti permanentnega pisala ...",
  "case change": "sprememba male\/velike \u010drke",
  "page embed": "vstavi stran",
  "Advanced sort...": "Napredno razvr\u0161\u010danje",
  "Advanced Sort": "Napredno razvr\u0161\u010danje...",
  "Sort table by column ascending": "Razvrsti tabelo po stolpcu nara\u0161\u010dajo\u010de",
  "Sort table by column descending": "Razvrsti tabelo po stolpcu padajo\u010de",
  "Sort": "Razvrsti",
  "Order": "Vrstni red",
  "Sort by": "Razvrsti po",
  "Ascending": "Nara\u0161\u010dajo\u010de",
  "Descending": "Padajo\u010de",
  "Column {0}": "Stolpec {0}",
  "Row {0}": "Vrstica {0}",
  "Spellcheck...": "\u010crkovalnik...",
  "Misspelled word": "\u00b8Nepravilno \u010drkovana beseda",
  "Suggestions": "Predlogi",
  "Change": "Spremeni",
  "Finding word suggestions": "Iskanje predlogov besed",
  "Success": "Uspe\u0161no",
  "Repair": "Popravi",
  "Issue {0} of {1}": "Te\u017eava {0} od {1}",
  "Images must be marked as decorative or have an alternative text description": "Slike morajo biti ozna\u010dene kot okrasne ali morajo imeti nadomestni opis v obliki besedila",
  "Images must have an alternative text description. Decorative images are not allowed.": "Slike morajo imeti nadomestni opis v obliki besedila.  Okrasne slike niso dovoljene.",
  "Or provide alternative text:": "Ali podajte nadomestno besedilo:",
  "Make image decorative:": "Dolo\u010di sliko kot okrasno:",
  "ID attribute must be unique": "ID atribut mora biti edinstven",
  "Make ID unique": "Ustvari edinstven ID",
  "Keep this ID and remove all others": "Obdr\u017ei ta ID in odstrani vse ostale",
  "Remove this ID": "Odstrani ta ID",
  "Remove all IDs": "Odstrani vse IDje",
  "Checklist": "Seznam preverjanj"
});